import "@/App.css";
import { MotionConfig } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import EmergencySupport from "@/pages/EmergencySupport";
import SaltwaterAquariums from "@/pages/SaltwaterAquariums";
import FreshwaterAquariums from "@/pages/FreshwaterAquariums";
import ReefAquariums from "@/pages/ReefAquariums";
import ServiceMaintenance from "@/pages/ServiceMaintenance";
import ServicesOverview from "@/pages/ServicesOverview";
import AquariumDesign from "@/pages/AquariumDesign";
import WaterDelivery from "@/pages/WaterDelivery";
import Guarantee from "@/pages/Guarantee";
import { Toaster } from "@/components/ui/sonner";
import { ChatWidget } from "@/components/site/ChatWidget";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

function App() {
  useSmoothScroll();
  return (
    <MotionConfig reducedMotion="never">
      <div className="App bg-[var(--ink)]">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/emergency" element={<EmergencySupport />} />
            <Route path="/saltwater" element={<SaltwaterAquariums />} />
            <Route path="/freshwater" element={<FreshwaterAquariums />} />
            <Route path="/reef" element={<ReefAquariums />} />
            <Route path="/maintenance" element={<ServiceMaintenance />} />
            <Route path="/services" element={<ServicesOverview />} />
            <Route path="/design" element={<AquariumDesign />} />
            <Route path="/water-delivery" element={<WaterDelivery />} />
            <Route path="/guarantee" element={<Guarantee />} />
          </Routes>
        </BrowserRouter>
        <ChatWidget />
        <Toaster position="top-center" theme="dark" richColors />
      </div>
    </MotionConfig>
  );
}

export default App;
